<template>
    <form action="">
        <app-form-text-input
            label="Nombre"
            v-model="kit.name"
            :has-error="$v.kit.name.$error"
            error-message="Debe escribir el nombre del kit"
            :required="true"
        />
        <app-form-text-input
            label="Referencia"
            v-model="kit.reference"
            :has-error="$v.kit.reference.$error"
            error-message="Debe escribir la referencia del kit"
            :required="true"
        />
        <app-currency-input
            v-model="kit.technical_labor"
            label="Mano de Obra Técnica"
            :has-error="$v.kit.technical_labor.$error"
            error-message="Debe ingresar un valor válido"
            required
        />

        <app-currency-input
            v-model="kit.installation_unforeseen"
            label="Imprevistos de Instalación (Categoría Labor)"
            :has-error="$v.kit.installation_unforeseen.$error"
            error-message="Debe ingresar un valor válido"
        />

        <app-currency-input
            v-model="kit.ladder_supply_transport"
            label="Suministro y Transporte de Escaleras Requeridas x Tiempo de Instalación (Categoría Labor)"
            :has-error="$v.kit.ladder_supply_transport.$error"
            error-message="Debe ingresar un valor válido"
        />

        <app-currency-input
            v-model="kit.installation_consumables"
            label="Consumibles de Instalación (Chazos, Tornillos, Amarras, etc) (Categoría Materiales)"
            :has-error="$v.kit.installation_consumables.$error"
            error-message="Debe ingresar un valor válido"
        />

        <app-currency-input
            v-model="kit.signage_fabrication"
            label="Fabricación de Señaliticas (Categoría Materiales)"
            :has-error="$v.kit.signage_fabrication.$error"
            error-message="Debe ingresar un valor válido"
        />

        <div class="form-group">
            <label class="form-label">
                Items del Kit
                <span class="text-danger">*</span>
            </label>
            <div v-if="itemOptions.length === 0" class="alert alert-warning">
                <small>No hay items disponibles. Por favor, asegúrese de que haya items creados en el sistema.</small>
            </div>
            <div class="kit-items-section">
                <div v-for="(kitItem, index) in kit.items" :key="index" class="kit-item-row mb-2 p-2 border rounded">
                    <div class="row align-items-center">
                        <div class="col-md-6">
                            <app-form-select2-input
                                :value="kitItem.item_id"
                                :options="itemOptions"
                                label="Item"
                                @input="updateKitItem(index, 'item_id', $event)"
                            />
                        </div>
                        <div class="col-md-3">
                            <app-form-text-input
                                label="Cantidad"
                                type="number"
                                :value="String(kitItem.quantity || '1')"
                                min="1"
                                @input="updateKitItem(index, 'quantity', $event)"
                            />
                        </div>
                        <div class="col-md-3">
                            <button 
                                type="button" 
                                class="btn btn-danger btn-sm mt-4"
                                @click="removeKitItem(index)"
                            >
                                <i class="fa fa-trash"></i> Eliminar
                            </button>
                        </div>
                    </div>
                </div>
                <button 
                    type="button" 
                    class="btn btn-secondary btn-sm"
                    @click="addKitItem"
                >
                    <i class="fa fa-plus"></i> Agregar Item
                </button>
            </div>
        </div>
    </form>
</template>
<script>
import FormTextInput from '../../../UI/Controls/Forms/FormTextInput.vue';
import FormSelect2Input from '../../../UI/Controls/Forms/FormSelect2Input.vue';
import CurrencyInput from '../../../UI/Controls/Forms/CurrencyInput.vue';
import { required, minValue } from 'vuelidate/lib/validators';
import kitsRepository from '../../../../repositories/kits.repository';

export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelect2Input: FormSelect2Input,
        appCurrencyInput: CurrencyInput
    },
    props: {
        selectedKit: {
            type: Object,
            default: null
        },
        availableItems: {
            type: Array,
            default: () => []
        },
        onSave: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            kit: {
                name: '',
                reference: '',
                technical_labor: 0,
                installation_unforeseen: null,
                ladder_supply_transport: null,
                installation_consumables: null,
                signage_fabrication: null,
                items: []
            }
        };
    },
    computed: {
        itemOptions() {
            if (!this.availableItems || this.availableItems.length === 0) {
                return [];
            }
            return this.availableItems.map(item => ({
                id: item.id,
                name: `${item.name} (${item.reference || ''})`
            }));
        }
    },
    validations: {
        kit: {
            name: { required },
            reference: { required },
            technical_labor: { required, minValue: minValue(0) },
            installation_unforeseen: { minValue: minValue(0) },
            ladder_supply_transport: { minValue: minValue(0) },
            installation_consumables: { minValue: minValue(0) },
            signage_fabrication: { minValue: minValue(0) },
            items: {
                required,
                minLength: (items) => items && items.length > 0
            }
        }
    },
    watch: {
        selectedKit: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.kit = {
                        name: newVal.name || '',
                        reference: newVal.reference || '',
                        technical_labor: parseFloat(newVal.technical_labor) || 0,
                        installation_unforeseen: newVal.installation_unforeseen ? parseFloat(newVal.installation_unforeseen) : null,
                        ladder_supply_transport: newVal.ladder_supply_transport ? parseFloat(newVal.ladder_supply_transport) : null,
                        installation_consumables: newVal.installation_consumables ? parseFloat(newVal.installation_consumables) : null,
                        signage_fabrication: newVal.signage_fabrication ? parseFloat(newVal.signage_fabrication) : null,
                        items: (newVal.items || []).map(item => ({
                            item_id: item.id,
                            quantity: String(item.pivot ? item.pivot.quantity : 1)
                        }))
                    };
                } else {
                    this.kit = {
                        name: '',
                        reference: '',
                        technical_labor: 0,
                        installation_unforeseen: null,
                        ladder_supply_transport: null,
                        installation_consumables: null,
                        signage_fabrication: null,
                        items: []
                    };
                }
            }
        },
        availableItems: {
            immediate: true,
            handler(newVal) {
                console.log('KitForm - availableItems changed:', newVal);
                console.log('KitForm - itemOptions computed:', this.itemOptions);
            }
        }
    },
    methods: {
        addKitItem() {
            this.kit.items.push({
                item_id: null,
                quantity: '1'
            });
        },
        removeKitItem(index) {
            this.kit.items.splice(index, 1);
        },
        updateKitItem(index, field, value) {
            if (field === 'quantity') {
                // Mantener como string para el input, pero validar que sea un número válido
                const numValue = parseInt(value) || 1;
                this.$set(this.kit.items[index], field, String(numValue));
            } else {
                this.$set(this.kit.items[index], field, value);
            }
        },
        save() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error('Por favor complete todos los campos requeridos');
                return;
            }

            const payload = {
                name: this.kit.name,
                reference: this.kit.reference,
                technical_labor: this.kit.technical_labor,
                installation_unforeseen: this.kit.installation_unforeseen || null,
                ladder_supply_transport: this.kit.ladder_supply_transport || null,
                installation_consumables: this.kit.installation_consumables || null,
                signage_fabrication: this.kit.signage_fabrication || null,
                items: this.kit.items.map(item => ({
                    item_id: item.item_id,
                    quantity: parseInt(item.quantity) || 1
                }))
            };

            const pr = { ...kitsRepository };
            const isEdit = this.selectedKit && this.selectedKit.id;

            if (isEdit) {
                pr.updateKit(payload, this.selectedKit.id)
                    .then(response => {
                        if (response && response.status) {
                            toastr.success(response.msg || 'Kit actualizado exitosamente');
                            this.onSave();
                        } else {
                            toastr.error(response?.msg || 'Error al actualizar el kit');
                        }
                    })
                    .catch(error => {
                        console.error('Error al actualizar kit:', error);
                        toastr.error('Error al actualizar el kit');
                    });
            } else {
                pr.saveKit(payload)
                    .then(response => {
                        if (response && response.status) {
                            toastr.success(response.msg || 'Kit creado exitosamente');
                            this.onSave();
                        } else {
                            toastr.error(response?.msg || 'Error al crear el kit');
                        }
                    })
                    .catch(error => {
                        console.error('Error al crear kit:', error);
                        toastr.error('Error al crear el kit');
                    });
            }
        }
    },
    mounted() {
        this.$bus.$on('kit-form.save', this.save);
        this.$bus.$on('kit-form.clear', () => {
            this.kit = {
                name: '',
                reference: '',
                technical_labor: 0,
                installation_unforeseen: null,
                ladder_supply_transport: null,
                installation_consumables: null,
                signage_fabrication: null,
                items: []
            };
            this.$v.$reset();
        });
        // Debug: verificar que los items se están recibiendo
        console.log('KitForm mounted - availableItems:', this.availableItems);
        console.log('KitForm mounted - itemOptions:', this.itemOptions);
        console.log('KitForm mounted - kit.items:', this.kit.items);
    },
    beforeDestroy() {
        this.$bus.$off('kit-form.save');
        this.$bus.$off('kit-form.clear');
    }
};
</script>

